export default __webpack_public_path__ + "static/media/pricingdiscovery.7f437c2d.png";